import React from "react";
import Chip from "@mui/material/Chip";
import { FonepayPaymentStatus as IFonepayPaymentStatus } from "../../../../../hooks/useFonePayWSS";

interface FonepayPaymentStatusProps {
  status: IFonepayPaymentStatus;
}

const statusMap: Record<
  Exclude<IFonepayPaymentStatus, null>,
  {
    label: string;
    color: "default" | "primary" | "success" | "error" | "warning" | "info" | "secondary";
  }
> = {
  PENDING: { label: "Processing", color: "warning" },
  VERIFIED: { label: "QR Scanned", color: "info" },
  COMPLETED: { label: "Completed", color: "success" },
  FAILED: { label: "Failed", color: "error" }
};

const FonepayPaymentStatus: React.FC<FonepayPaymentStatusProps> = ({ status }) => {
  if (!status) return null;

  const { label, color } = statusMap[status] ?? {
    label: "Unknown",
    color: "default" as const
  };

  return <Chip label={label} color={color} size="small" />;
};

export default FonepayPaymentStatus;
